// extracted by mini-css-extract-plugin
export default {"commonHeader":"styles_commonHeader__EiZUK","sellerHeader":"styles_sellerHeader__9uFIm","buyerHeader":"styles_buyerHeader__BTPY8","border":"styles_border__Mib8x"};